<template>
  <div>
    <admin-sidebar></admin-sidebar>
    <section id="dashboard">
      <div class="container">
        <form>
            
            <div class="row"> 
                <div class="col-12">
                    <div class="white-background mb-30">
                        <div class="form-group">
                            <label>Të dhënat e perdoruesit</label>
                            <table class="table">
                                <colgroup>
                                    <col style="width:30%">
                                    <col style="width:70%">
                                </colgroup>
                                <tr v-if="!userDetails.is_business">
                                    <td>Emri</td>
                                    <td><input class="form-control" type="text" v-model="userDetails.first_name" :disabled="isDriver"></td>
                                </tr>
                                <tr v-if="!userDetails.is_business">
                                  <td>Mbiemri</td>
                                  <td><input class="form-control" type="text" v-model="userDetails.last_name" :disabled="isDriver"></td>
                                </tr>
                                <tr v-if="userDetails.is_business">
                                  <td>Kompania</td>
                                  <td><input class="form-control" type="text" v-model="userDetails.company_name" :disabled="isDriver"></td>
                                </tr>
                                <tr>
                                    <td>Email</td>
                                    <td><input class="form-control" v-model="userDetails.email" disabled></td>
                                </tr>
                                <tr>
                                    <td>Telefoni</td>
                                    <td><input class="form-control" v-model="userDetails.phoneNumber" :disabled="isDriver"></td>
                                </tr>
                                <tr>
                                    <td>Pako</td>
                                    <td v-if="userDetailSubscription.paketa">{{ userDetailSubscription.paketa.name }}</td>
                                </tr>
                                <tr>
                                    <td>Kartela e Lojalitetit</td>
                                    <td><input class="form-control" v-model="userDetails.marimanga_card_id" :disabled="isDriver"></td>
                                </tr>
                            </table>
                        </div>
                      <div>
                        <label>Të referuarit</label>
                        <div class="referred-users-table" v-if="getReferredUsersArraySize">
                          <table class="table table-bordered table-striped text-center">
                            <thead class="sticky-top bg-white">
                              <tr>
                                <th>Emri</th>
                                <th>Email</th>
                                <th>Data e regjistrimit</th>
                                <th>Bonusi fituar</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="referred in userDetails.referred_users" :key="referred.id">
                                <td>{{ referred.referred_user.first_name }} {{ referred.referred_user.last_name }}</td>
                                <td>{{ referred.referred_user.email }}</td>
                                <td>{{ formatDate(referred.created_at) }}</td>
                                <td>{{ referred.is_used === 0 ? referred.value : "I shpenzuar" }}</td>
                              </tr>
                              <tr>
                                <td colspan="3" class="text-right"><b>Total në dispozicion:</b></td>
                                <td><b>{{ totalBonus }} €</b></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div v-else>Për momentin nuk keni referime aktive!</div>
                      </div>

                      <!-- <div class="form-group">
                          <label>Kartela e Lojalitetit</label>
                          <table class="table">
                          <colgroup>
                              <col style="width:30%">
                              <col style="width:70%">
                          </colgroup>
                          <tr>
                              <td>Numri i Karteles</td>
                              <td><input class="form-control" v-model="userDetails.marimanga_card_id"></td>
                          </tr>
                          </table>
                      </div> -->
                        <hr>
                        <div class="form-group" v-if="userDetailVehicles.length">
                            <label>Te dhenat e {{ userDetailVehicles.length === 1 ? 'vetures' : 'veturave' }}</label>
                            <div v-for="vehicle in userDetailVehicles" :key="vehicle.chassis_number">
                                <table class="table">
                                    <colgroup>
                                        <col style="width:30%">
                                        <col style="width:70%">
                                    </colgroup>
                                    <tr>
                                        <td>Targat e vetures</td>
                                        <td>
                                            <input class="form-control" v-model="vehicle.vehicle_registration_number" :disabled="isDriver">
                                        </td>
                                        <!-- <td>{{ vehicle.vehicle_registration_number }}</td> -->
                                    </tr>
                                    <tr>
                                        <td>Modeli i vetures</td>
                                        <td>
                                            <select class="text-secondary" name="payment-term" v-model="vehicle.vehicle_type" required :disabled="isDriver">
                                                <option disabled value>Zgjedh llojin e automjetit</option>
                                                <option
                                                    v-for="brand in brandNames"
                                                    :key="brand"
                                                    :value="brand"
                                                    :disabled="brand === ''"
                                                    >{{ brand }}
                                                </option>
                                            </select>
                                        </td>
                                        <!-- <td>{{ vehicle.vehicle_type }}</td> -->
                                    </tr>
                                    <tr>
                                        <td>Transmisioni</td>
                                        <td>
                                            <select class="text-secondary" v-model="vehicle.gear_type" :disabled="isDriver">
                                                <option value>Zgjedh transmisionin</option>
                                                <option value="automatic">Automatik</option>
                                                <option value="manual">Manual</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Viti i regjistrimit</td>
                                        <td>
                                            <input class="form-control" v-model="vehicle.registration_year" :disabled="isDriver">
                                        </td>
                                        <!-- <td>{{ vehicle.registration_year }}</td> -->
                                    </tr>
                                    <tr>
                                        <td>Pronari i Automjetit sipas Librezes</td>
                                        <td>
                                            <input class="form-control" v-model="vehicle.vehicle_owner_name" :disabled="isDriver">
                                        </td>
                                    </tr>
                                    <tr>
                                      <td>Data fillimit te pakos:</td>
                                      <td>
                                        <p><strong>{{ formatDate(vehicle.active_subscription.start_date) }}</strong></p>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Data skadimit te pakos:</td>
                                      <td>
                                        <p><strong>{{ formatDate(vehicle.active_subscription.end_date) }}</strong></p>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Numri i intervenimeve</td>
                                      <td>{{ vehicle.completed_requests }}</td>
                                    </tr>
                                    <tr>
                                      <td>Distanca e mbuluar gjatë intervenimeve</td>
                                      <td>{{ transformDistance(vehicle.interventions_distance) }}</td>
                                    </tr>
                                    <tr v-if="!isDriver">
                                        <td>Aksionet</td>
                                        <td>
                                            <button class="btn-custom-success p-1"  type @click.prevent="updateVehicle(vehicle)">ruaj</button>
                                        </td>
                                    </tr>
                                </table>
                                <hr>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="d-flex flex-column flex-md-row justify-content-between confirmation">
                        <router-link tag="button" to="/admin/clients" class="mb-2 mb-md-0">kthehu</router-link>
                        <button v-if="!isDriver" class="mb-2 mb-md-0 btn-custom-success" type @click="updateUser">ruaj ndryshimet</button>
                        <button v-if="!isDriver" class="mb-2 mb-md-0 btn-custom-danger" type @click="deleteUser">fshije shfrytezuesin</button>
                    </div>
                </div>
            </div>
        </form>
      </div>
    </section>
  </div>
</template>

<style src="@/assets/admin/css/main.css">
</style>
<style scoped>
.table td {
    padding: 10px!important;
    border-top: 0px!important;
}
.form-group input {
    width: 100%!important;
}
</style>

<script>
import AdminSidebar from "@/components/admin/AdminSidebar";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "AdminUserDetail",
  components: {
    AdminSidebar: AdminSidebar
  },
  methods: {
    formatDate(date) {
      if (date) {
        return moment(String(date)).format('DD.MM.YYYY')
      }
    },
      async updateVehicle(vehicle) {
          await this.$store.dispatch("clients/updateVehicle",vehicle);
          this.$store.dispatch("clients/getUserDetail", this.$route.params.id);
      },
      async updateUser(e) {
        e.preventDefault();
        await this.$store.dispatch("clients/updateUser",this.$route.params.id);
        this.$store.dispatch("clients/getUserDetail", this.$route.params.id);
      },
    deleteUser(e) {
      e.preventDefault();
      if(confirm("A jeni të sigurt se dëshironi ta fshini këtë shfrytëzues?")) { 
        
        this.$store.dispatch("requests/deleteUser",this.$route.params.id);
      } 
    },
    getAmount(e) {
      this.$store.dispatch("finances/getAmount", e.target.value);
    },
    toggleApproved() {
      this.$store.dispatch("finances/toggleApproved");
    },
    getApprovedAt(e) {
      this.$store.dispatch("finances/getApprovedAt", e.target.value);
    },
    getPaymentType(e) {
      this.$store.dispatch("finances/getPaymentType", e.target.value);
    },
    updateRequestDetail(e) {
      e.preventDefault();
      this.$store.dispatch(
        "requests/updateRequestDetail",
        this.$route.params.id
      );
    },
    transformDistance(distance){
      if(distance > 1000){
        return (distance / 1000).toFixed(2) + ' km';
      }
      return distance + ' m';
    }
  },
  computed: {
    ...mapGetters({
        brandNames: "billing/brandNames",
      amount: "finances/amount",
      approved: "finances/approved",
      approvedAt: "finances/approvedAt",
      paymentType: "finances/paymentType",
      packageDetails: "finances/packageDetails",
      userDetails: "clients/userDetails",
      userDetailVehicles: "clients/userDetailVehicles",
      userDetailSubscription: "clients/userDetailSubscription"
    }),
    totalBonus() {
      return this.userDetails.total_bonus.toFixed(2);
    },
    getReferredUsersArraySize() {
      return this.userDetails.referred_users ? this.userDetails.referred_users.length : 0;
    },
    isDriver() {
      return this.user().user_type === 'driver';
    }
  },
  beforeMount() {
    this.$store.dispatch("clients/getUserDetail", this.$route.params.id);
  }
};
</script>
